/* unplugin-vue-components disabled */import { render } from "./News.vue?vue&type=template&id=4eef6b9d&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=4eef6b9d&lang=scss&scoped=true"
import "./News.vue?vue&type=style&index=1&id=4eef6b9d&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eef6b9d"]])

export default __exports__